import { type TriScaleOptions, type TriScaleMode,  type HSL, createTriScale, toHslCss } from '@/lib/colorScale'

const red: HSL = { h: 0, s: 100, l: 50 }
const green: HSL = { h: 120, s: 100, l: 50 }
const purple: HSL = { h: 270, s: 75, l: 55 }
const teal: HSL = { h: 160, s: 75, l: 55 }
const pink: HSL = { h: 330, s: 75, l: 55 }
const blue: HSL = { h: 210, s: 85, l: 55 }
const yellow: HSL = { h: 55, s: 95, l: 55 }
const orange: HSL = { h: 30, s: 95, l: 55 }
const cyan: HSL = { h: 180, s: 100, l: 50 }
const neutral_steel: HSL = { h: 210, s: 10, l: 50 }

const yellow_mid: HSL = { h: 55, s: 45, l: 70 }
const orange_mid: HSL = { h: 30, s: 45, l: 70 }
const purple_mid: HSL = { h: 270, s: 45, l: 70 }

export const PALETTES = {
  redYellowGreen: {low: red, midColor: yellow, high: green, neutral: neutral_steel, min: 0, mid: 50, max: 100, legacyNeutralValue:999 },
  blueYellowPink: { low: blue, midColor: yellow_mid, high: pink, neutral: neutral_steel, min:0, mid:50, max:100, legacyNeutralValue:999, mode: 'locked'},
  cyanOrangePurple: {low: cyan, midColor: orange_mid, high: purple, neutral: neutral_steel, min:0, mid:50, max:100, legacyNeutralValue:999, mode: 'locked' }
} satisfies Record<string, TriScaleOptions>

export type PaletteId = keyof typeof PALETTES

export const PALETTE_IDS = Object.keys(PALETTES) as PaletteId[]

export function isPaletteId(x: unknown): x is PaletteId {
  return typeof x === 'string' && x in PALETTES
}

export function createScaleForPalette(id: PaletteId, mode: TriScaleMode = 'blend' ) {
  return createTriScale({
    ...
    PALETTES[id],
    //mode: mode
    mode: 'blend'
  })
}

export const PALETTE_OPTIONS = [
  { id: 'redYellowGreen' },
  { id: 'blueYellowPink' },
  { id: 'cyanOrangePurple' }
] as const satisfies ReadonlyArray<{ id: PaletteId }>

export function palettePreviewCss(id: PaletteId) {
  const p = PALETTES[id]
  const neutral = typeof p.neutral === 'string' ? p.neutral : toHslCss(p.neutral)
  return {
    low: toHslCss(p.low),
    mid: toHslCss(p.midColor),
    high: toHslCss(p.high),
    neutral,
  }
}
